// #region Dependencias
import { Form, InputRange } from 'components/Library'
// #endregion

/**
 * Componente que maneja la edición del borde de landing pages.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {number} props.borde - Valor de border radius de la aplicación.
 * @param {Function} props.handleInputChange - Callback para actualizar los valores de un elemento de la página.
 */
const MenuBorder = ({ borde, handleInputChange }) => {
  return (
    <Form
      style={{
        padding: '1rem'
      }}
    >
      <InputRange
        label="Borde"
        name="opciones.borde"
        min={0}
        max={3}
        step={0.1}
        value={borde}
        onChange={handleInputChange}
      />
    </Form>
  )
}

export default MenuBorder
